import { Button, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from '@fluentui/react-components';
import { DeleteFilled, EditFilled } from '@fluentui/react-icons';
import { format, parseISO } from 'date-fns';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../common/hooks';
import { EmailTemplateRef } from '../../../models';
import { FlexBox } from '../../shared-components/flex-box';
import './MyTemplatesTable.scss';

interface Props {
  onEditEmailTemplate(emailTemplateId: number): void;
  onDeleteEmailTemplate(emailTemplateId: number): void;
}

const MyTemplatesTableImpl: React.FC<Props> = props => {
  const {
    onEditEmailTemplate,
    onDeleteEmailTemplate
  } = props;

  const {
    emailPageUiStore,
  } = useStores();

  const renderRecipients = (emailTemplate: EmailTemplateRef): string => {
    return [
      ...(emailTemplate.targetGroups.map((group) => group.displayName) || []),
      ...(emailTemplate.individualRecipients || [])
    ].join(', ');
  };

  return (
    <Table
      className='my-templates-table'
    >
      <TableHeader>
        <TableRow>
          <TableHeaderCell className='col-title'>Email title</TableHeaderCell>
          <TableHeaderCell>Created</TableHeaderCell>
          <TableHeaderCell>Last updated</TableHeaderCell>
          <TableHeaderCell>By</TableHeaderCell>
          <TableHeaderCell>Recipients</TableHeaderCell>
          <TableHeaderCell className='col-actions' />
        </TableRow>
      </TableHeader>

      <TableBody>
        {
          emailPageUiStore.sortedEmailTemplateRefs.length ? emailPageUiStore.sortedEmailTemplateRefs.map((emailTemplate) => (
            <TableRow
              key={emailTemplate.emailTemplateId}
            >
              <TableCell className='col-title'>{emailTemplate.title}</TableCell>
              <TableCell>{format(parseISO(emailTemplate.createdDateTime), 'MM/dd/yyyy @ h:mm aaa')}</TableCell>
              <TableCell>
                {emailTemplate.lastUpdatedDateTime ? format(parseISO(emailTemplate.lastUpdatedDateTime), 'MM/dd/yyyy @ h:mm aaa') : ''}
              </TableCell>
              <TableCell>{emailTemplate.by}</TableCell>
              <TableCell>{renderRecipients(emailTemplate)}</TableCell>
              <TableCell
                className='col-actions'
              >
                <FlexBox>
                  <Button
                    appearance='transparent'
                    icon={<EditFilled />}
                    title='Edit'
                    onClick={() => onEditEmailTemplate(emailTemplate.emailTemplateId)}
                  />
                  <Button
                    appearance='transparent'
                    icon={<DeleteFilled />}
                    title='Delete'
                    onClick={() => onDeleteEmailTemplate(emailTemplate.emailTemplateId)}
                  />
                </FlexBox>
              </TableCell>
            </TableRow>
          )) : (
            <TableRow className='row-empty'>
              <TableCell colSpan={6}>
                <FlexBox
                  isFullWidth
                  content='center'
                >
                  No template
                </FlexBox>
              </TableCell>
            </TableRow>
          )
        }
      </TableBody>
    </Table>
  );
}

export const MyTemplatesTable = observer(MyTemplatesTableImpl);
